import React from "react"
import "./AboutUs.css"
import front from "../assets/architect.png"
import front2 from "../assets/architect2.png"
import front3 from "../assets/office2.png"
import { BlurFade } from "./magicui/blur-fade.tsx"
import { TextAnimate } from "./magicui/text-animate.tsx"
import { NumberTicker } from "./magicui/number-ticker.tsx"
import { VelocityScroll } from "./magicui/scroll-based-velocity.tsx"
import { AuroraText } from "./magicui/aurora-text"
import { useTranslation } from "react-i18next"

const AboutUs = () => {

  const { t, i18n } = useTranslation()

    return (
        <section className="about-us-section">
            <BlurFade delay={0.25} inView>  
              <div className="section-title-container">
                <div className="mini-title-about">
                  {t('home.about_us.title_card')}
                </div>
                <div>
                  <h2 className="section-main-title">
                    {t('home.about_us.main_title')} <AuroraText>{t('home.about_us.main_title_special')}</AuroraText>
                  </h2>
                </div>
              </div>
            </BlurFade>
            <div className="child-sections-container">
              <div className="container-full">
                <BlurFade delay={0.25} className="w-full" inView>
                  <div className="image_c_in">
                      <div className="bg-image"></div>
                    <div className="front-image">
                      <BlurFade delay={0.50} inView className="flex-default">
                        <img className="image_in_bg" src={front} alt="Building" draggable={false} />
                      </BlurFade>
                    </div>
                  </div>
                </BlurFade>
              </div>
              <div className="content-about-container">
                <div className="text-about-container">
                  <div>
                    <h2 className="about-mini-section-title">
                      <TextAnimate animation="blurInUp" by="character" once>
                      {t('home.about_us.section.our_mission.title')}
                      </TextAnimate>
                    </h2>
                  </div>
                  <div>
                      <BlurFade inView delay={0.5} className="p-tag-about">
                        {t('home.about_us.section.our_mission.text')}
                      </BlurFade>
                  </div>
                </div>
                <BlurFade delay={0.5} direction="up" inView>
                  <div className="list-display">
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_mission.list.element_one')}
                      </div>
                    </div>
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_mission.list.element_two')}
                      </div>
                    </div>
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_mission.list.element_three')}
                      </div>
                    </div>
                  </div>
                </BlurFade>
              </div>
            </div>
            <div className="horizontal-number-container">
              <div className="par-number-container-stats">
                <div className="number-ticker-stats">
                  <div className="plus flex-default">
                    +
                  </div>
                  <NumberTicker
                        value={20}
                        direction="up"
                        className="text-[34px] font-semibold font-Inter"
                      />
                  
                </div>
                <div className="number-info-txt">
                  {t('home.about_us.section.stats.box_one')}
                </div>
              </div>
              <div className="par-number-container-stats">
                <div className="number-ticker-stats">
                  <div className="plus flex-default">
                    +
                  </div>
                  <NumberTicker
                        value={15}
                        direction={"up"}
                        className="text-[34px] font-semibold font-Inter"
                      />
                </div>
                <div className="number-info-txt">
                  {t('home.about_us.section.stats.box_two')}
                </div>
              </div>
              <div className="par-number-container-stats">
                <div className="number-ticker-stats">
                  <NumberTicker
                        value={150}
                        direction={"up"}
                        className="text-[34px] font-semibold font-Inter"
                      />
                  <div className="plus flex-default">
                    %   
                  </div>
                </div>
                <div className="number-info-txt">
                  {t('home.about_us.section.stats.box_three')}
                </div>
              </div>
              <div className="par-number-container-stats">
                <div className="number-ticker-stats">
                  <NumberTicker
                        value={6}
                        direction={"up"}
                        className="text-[34px] font-semibold font-Inter"
                      />
                </div>
                <div className="number-info-txt">
                  {t('home.about_us.section.stats.box_four')}
                </div>
              </div>
            </div>
            <div className="child-sections-container">
              <div className="content-about-container">
                <div className="text-about-container">
                  <div>
                    <h2 className="about-mini-section-title">
                      <TextAnimate animation="blurInUp" by="character" once>
                      {t('home.about_us.section.our_vision.title')}
                      </TextAnimate>
                    </h2>
                  </div>
                  <div>
                      <BlurFade inView delay={0.5} className="p-tag-about">
                        {t('home.about_us.section.our_vision.text')}
                      </BlurFade>
                  </div>
                </div>
                <BlurFade delay={0.5} direction="up" inView>
                  <div className="list-display">
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_vision.list.element_one')}
                      </div>
                    </div>
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_vision.list.element_two')}
                      </div>
                    </div>
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_vision.list.element_three')}
                      </div>
                    </div>
                  </div>
                </BlurFade>
              </div>
              <div className="container-full">
                <BlurFade delay={0.25} className="w-full" inView>
                  <div className="image_c_in">
                      <div className="bg-image-2"></div>
                    <div className="front-image-left">
                      <BlurFade delay={0.50} inView className="flex-default">
                        <img className="image_in_bg" src={front2} alt="Building" draggable={false} />
                      </BlurFade>
                    </div>
                  </div>
                </BlurFade>
              </div>
            </div>
            <div className="relative flex w-full flex-col items-center justify-center overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
              <VelocityScroll>Knowledge Impact</VelocityScroll>
              <div className="pointer-events-none absolute inset-y-0 left-0 w-1/4 bg-gradient-to-r from-background"></div>
              <div className="pointer-events-none absolute inset-y-0 right-0 w-1/4 bg-gradient-to-l from-background"></div>
            </div>
            <div className="child-sections-container">
              <div className="container-full">
                <BlurFade delay={0.25} className="w-full" inView>
                  <div className="image_c_in">
                      <div className="bg-image-3"></div>
                    <div className="front-image">
                      <BlurFade delay={0.50} inView className="flex-default">
                        <img className="image_in_bg" src={front3} alt="Building" draggable={false} />
                      </BlurFade>
                    </div>
                  </div>
                </BlurFade>
              </div>
              <div className="content-about-container">
                <div className="text-about-container">
                  <div>
                    <h2 className="about-mini-section-title">
                      <TextAnimate animation="blurInUp" by="character" once>
                      {t('home.about_us.section.our_history.title')}
                      </TextAnimate>
                    </h2>
                  </div>
                  <div>
                      <BlurFade inView delay={0.5} className="p-tag-about">
                        {t('home.about_us.section.our_history.text')}
                      </BlurFade>
                  </div>
                </div>
                <BlurFade delay={0.5} direction="up" inView>
                  <div className="list-display">
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_history.list.element_one')}
                      </div>
                    </div>
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_history.list.element_two')}
                      </div>
                    </div>
                    <div className="list-child-about">
                      <div className="flex-default">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 21" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-icon lucide-check"><path d="m17.5 5.25-9.625 9.625L3.5 10.5"/></svg>
                      </div>
                      <div>
                        {t('home.about_us.section.our_history.list.element_three')}
                      </div>
                    </div>
                  </div>
                </BlurFade>
              </div>
            </div>
        </section>
    )
}

export default AboutUs